import { ko } from "src/i18n/ko";

const $Common = {
  all: "All",
  cancel: "Cancel",
  modification: "Modification",
  cancelModification: "Cancel modification",
  confirmDelete: "Are you sure you want to delete this?",
  delete: "Delete",
  message: "Message",
  greeting: "Hi There!",
  goodbye: "Goodbye!",
  none: "None",
  ok: "OK",
  or: "or",
  subtitle: "",
  title: "",
  unknown: "Unknown",
  content: "",
  save: "Save",
  nodata: "There is no data.",

  userManagement: "User management",
  serviceName: "StroKcare",
  language: "language",
  dashboard: "Dashboard",
  points: "points",

  // 날짜 관련
  weekdaysLong: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday",
  weekdaysShort: "Sun Mon Tue Wed Thu Fri Sat",
  today: "Today",
  yesterday: "Yesterday",
  weekly: "Weekly",
  daily: "Daily",
  monthly: "Monthly",
  year: "Year",
  month: "Month",
  day: "Day",
  second: "second",
  before: "before",
  monday: "monday",
  tuesday: "tuesday",
  wednesday: "wednesday",
  thursday: "thursday",
  friday: "friday",
  saturday: "saturday",
  sunday: "sunday",

  // 환자 관련
  displayName: "Name",
  patientCode: "Patient number",
  age: "Age",
  birth: "Birth date",
  gender: "Gender",
  state: "State",
  lastEvaluationDt: "Last evaluation",
  male: "male",
  female: "female",
  phone: "Phone",
  address: "address",
  firstOutbreakDt: "first outbreak date",
  recentVisitDt: "recent visit",
  diseaseType: "disease type",
  disabilityType: "disability type",
  authenticationNumber: "Authentication number",
  email: "email",

  required: "This is required.",
  notValidBlanked: "Blank are not allowed",
  notValidEmail: "Please enter a valid email address.",
  notValidPhone: "Please enter a valid phone number.",
  lessThanNumCharacter: "Please enter a value less than {msg}.",
  moreThanNumCharacter: "Please enter a value more than {msg}.",
  moreThanNum: "Please enter a value more than {msg}.",
};

const $Report = {
  Achievement: "Achievement",
  Responsibility: "Responsibility",
  Attention: "Attention",
  Sadness: "Sadness",
  Anger: "Anger",
  Resilience: "Resilience",
  Mindful: "Mindful",
  Monitoring: "Monitoring",
  Neat: "Neat",
  anxiety: "anxiety",
  gloom: "gloom",
  stress: "stress",
  selfControl: "",
  mood: "",
  metaCognitive: "",
  mindState: "",
};
export const en: typeof ko = {
  AppBar: {
    ...$Common,
  },
  TriangleChart: {
    ...$Common,
    ...$Report,
  },
  StateExpansionItem: {
    ...$Common,
    ...$Report,
  },
};
